'use client';

import type { Comedian_Entry } from '@/types/custom';
import ArtistAvatar from './ArtistAvatar';

interface ArtistAvatarListProps {
    artists: Comedian_Entry[];
}

export default function ArtistAvatarList({ artists }: ArtistAvatarListProps) {
    return (
        <div className="artist-avatar-list mb-4">
            {artists.map((artist) => (
                <ArtistAvatar
                    key={artist?.id}
                    slug={artist?.slug}
                    avatar={artist?.avatars?.[0] || null}
                    className="w-1/6"
                />
            ))}
        </div>
    );
}
